import React from "react";
import { Typography, List, ListItem, ListItemText } from "@mui/material";
import { useThemeColors } from "../../Context/Theme";

const TermsSection = ({ title, items, nested, isNestedStyleDisc }) => {
    const {
      fontFamily,
      fontWeight,
      fontSize,
      fontFamilyHeading,
      fontWeightHeading,
      fontSizeHeading
    } = useThemeColors();
  return (
    <>
      {title && title!== "" && <Typography
        variant="h6"
        sx={{ marginTop: nested ? 0 : 2, textAlign: "center", fontWeight: fontWeightHeading || "500", fontSize: fontSizeHeading, fontFamily: fontFamilyHeading }}
      >
        {title}
      </Typography>}
      <List
        sx={{
          listStyleType: "disc",
          paddingLeft: nested ? 12 : 6,
          "& .MuiListItem-root": { display: isNestedStyleDisc ? "list-item" : "" },
        }}
      >
        {items.map((item, index) => (
          <ListItem sx={{ padding: 0 }} key={index}>
            <ListItemText
              primary={
                <Typography sx={{ fontSize: nested ? "14px" : "14px", fontFamily }} >
                  {item}
                </Typography>
              }
            />
          </ListItem>
        ))}
      </List>
    </>
  );
};

export default TermsSection;
